import EsusView from 'components/esus/EsusView'
import { useLocation } from 'react-router'

export default function FichaCadastroDomiciliarDetailView() {
  const { search } = useLocation()

  return <EsusView url={`/pec/user/cds/cadastroDomiciliar/detail${search}`} />
}
